import script from "./Auth0User.vue?vue&type=script&lang=ts&setup=true"
export * from "./Auth0User.vue?vue&type=script&lang=ts&setup=true"

import "./Auth0User.vue?vue&type=style&index=0&id=40b87f6e&lang=css"

const __exports__ = script;

export default __exports__